module.exports = __webpack_public_path__ + "app-static/img/p_06.681fbf95.jpg";